var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOpenLarge = function SvgEyeOpenLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.6 18.747c1.95 2.958 6.284 7.92 13.4 7.92s11.45-4.964 13.401-7.922a4.98 4.98 0 0 0 0-5.493c-1.95-2.959-6.284-7.92-13.4-7.92s-11.452 4.961-13.402 7.92a4.98 4.98 0 0 0 0 5.495m2.225-4.027C6.48 12.212 10.132 8 16 8s9.52 4.212 11.175 6.722a2.35 2.35 0 0 1 0 2.558C25.52 19.788 21.87 24 16 24c-5.868 0-9.52-4.212-11.175-6.722a2.35 2.35 0 0 1 0-2.558M21.778 16a5.778 5.778 0 1 1-11.556 0 5.778 5.778 0 0 1 11.556 0",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpenLarge;